import './df-icon.less'
import NavItem from "./df-nav-item";
import vHoverStyle from './v-hover-style.directive'
export default function(Vue) {
    Vue.component(NavItem.name, NavItem)
    Vue.use(vHoverStyle)
}
